import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { isValidLogin } from '_core/helpers/validations';
import { IDocs } from '_core/types';
import { recoverBigDataQuestionApi as API } from '../Apis';

export const RecoverBigDataQuestionDocs: IDocs = {
  title: 'RecoverBigDataQuestion',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.recoverBigDataQuestion',
};

const prepareCall = (stateRequestParameters: any) => {
  const login = isValidLogin(stateRequestParameters.login);
  return API.call.post(
    login.type === 'EMAIL'
      ? {
          email: stateRequestParameters.login.toLowerCase(),
        }
      : login.type === 'MEMBER'
      ? { memberNumber: stateRequestParameters.login }
      : { document: { type: 'CPF', value: stateRequestParameters.login } },
  );
};

export const RecoverBigDataQuestionMachine = GenericMachine(prepareCall, {
  docs: RecoverBigDataQuestionDocs,
  definitions: API.definitions,
});
